<div
    class="cmps-event-centre-c-pop-footer--footer cmps-cdk-align-items-center cmps-cdk-pt-1 cmps-cdk-px-1"
>
    <img
        src="assets/intelligent-coach-assist-logo-horizontal.svg"
        alt=""
    />
    <div
        class="cmps-event-centre-c-pop-footer--pos cmps-cdk-color-grey-400"
        *ngIf="_data?.multiple"
    >
        <span>{{ _data?.pos }} / {{ _data?.length }}</span>
    </div>
</div>

<div
    class="cmps-event-centre-c-pop-footer--progress cmps-cdk-bg-color-grey-300"
    *ngIf="_data?.multiple"
>
    <div
        [style.width.%]="_data?.progress"
        class="cmps-event-centre-c-pop-footer--progress-bar cmps-cdk-bg-color-blue-100"
    ></div>
</div>
